import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const CustomTooltip = withStyles(theme => ({
  tooltip: {
    wordBreak:"break-all"
  },
}))(Tooltip);


export default CustomTooltip;